import { createFileRoute } from '@tanstack/react-router';

import { CreatePlanPage } from '@/features/plans/CreatePlanPage';

/**
 * "New plan" route. Captures the plan name and an initial floorplan image,
 * creates the floorplan + first page rows, and routes to the editor.
 */
export const Route = createFileRoute('/_app/plans/new')({
  component: CreatePlanPage,
});
